module.exports = __webpack_public_path__ + "static/media/logo.d353b088.png";